module.exports = __webpack_public_path__ + "img/intent_10.58c7c1f9.png";